import ProductsListHeader from './ProductsListHeader';

export default ProductsListHeader;
